export default __webpack_public_path__ + "static/media/browser-360.e5238822.webp";